import React from 'react';
import Pagination from '../../../../Components/Utils/Pagenation';
import ClientTicketCard from './ClientTicketCard';
import FileIcon from '../../../../Components/Icons/FileIcon';

function MobileClientTicketIndex({ data,dataLoading, total, getData, pageIndex, setPageIndex, dataCount, setDataCount }) {
  return (
    <div className="w-full h-[calc(100vh-160px)]">
      <div className="w-full h-[calc(100vh-199px)] overflow-y-auto py-1 px-2">
      {dataLoading == true ? (
                <>
                  <div className=" w-full h-[50vh] flex justify-center items-center">
                    <div className=" flex flex-col justify-center items-center">
                      <div className="flex flex-row gap-2">
                        <div className="w-3 h-3 rounded-full bg-baseColor-quartary animate-bounce" />
                        <div className="w-3 h-3 rounded-full bg-baseColor-quartary animate-bounce [animation-delay:-.3s]" />
                        <div className="w-3 h-3 rounded-full bg-baseColor-quartary animate-bounce [animation-delay:-.5s]" />
                        <div className="w-3 h-3 rounded-full bg-baseColor-quartary animate-bounce [animation-delay:-.7s]" />
                      </div>
                    </div>
                  </div>
                </>
              ) : (
        
          <div className="grid grid-cols-1 md:grid-cols-2  lg:grid-cols-4 gap-4">
             {data.length > 0 ? (
               <> 
          {data &&
            data.map((item, index) => (
              <ClientTicketCard item={item} getData={getData} key={index} />
            ))}
            </>
             ) : (
                                <>
                                  <div className=" w-full h-[50vh] flex justify-center items-center">
                                    <div className=" flex flex-col justify-center items-center">
                                      <FileIcon />
                                      <p className=" font-medium text-sm 2xl:text-base text-baseColor-secondary my-2">
                                        No Data found
                                      </p>
                                    </div>
                                  </div>
                                </>
                              )}
        </div>
        )}
      </div>

      <div className="w-full h-8">
        <Pagination
          total={total}
          pageIndex={pageIndex}
          setPageIndex={setPageIndex}
          dataCount={dataCount}
          setDataCount={setDataCount}
        />
      </div>
    </div>
  );
}

export default MobileClientTicketIndex;
